import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { PODGO_VERSION_FALLBACK } from "@/version";

interface Options {
  /** Polling interval in ms. When set, overrides the default 30-min staleTime. */
  pollMs?: number;
}

export function usePodgoVersion(options: Options = {}) {
  const { pollMs } = options;

  const { data: version = PODGO_VERSION_FALLBACK } = useQuery({
    queryKey: ["podgo-version"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("admin_settings")
        .select("value")
        .eq("key", "podgo_version")
        .single();

      if (error || !data?.value) return PODGO_VERSION_FALLBACK;
      return data.value;
    },
    staleTime: pollMs ?? 1000 * 60 * 30,
    refetchInterval: pollMs,
    refetchIntervalInBackground: false,
    retry: 1,
  });

  return { version };
}
